import classNames from "classnames/bind";
import styles from "./ModalCarpark.module.css";
import { Image, Modal, Space, Typography } from "antd";
import { useEffect, useState } from "react";
import { resolution } from "./Config";
import { formatDateToTime } from "../../../../../utils";


const cx = classNames.bind(styles);

function ModalLicense({ info, handleClose }) {
    const [detail, setDetail] = useState({});

    const handleSetUpInfo = (info) => {
        const infoRegion = {
            height: info?.height_image || 360,
            width: info?.width_image || 640,
            path: process.env.REACT_APP_FSR_EVENT + info?.image,
            license_plate: info?.infoLisence?.license_plate || '',
            time: info?.infoLisence?.time || '',
            object: info?.infoLisence?.object || ''
        }
        setDetail(infoRegion);
    }

    useEffect(() => {
        handleSetUpInfo(info);
    }, [info])

    return (
        <Modal
            open={info?.show}
            onCancel={handleClose}
            footer={<></>}
            centered
            className={cx('modal')}
        >
            <div className={cx('image')} >
                <Image
                    src={detail?.path}
                    width={640}
                    height={360}
                />
                {detail && detail?.license_plate && (
                    <div className={cx('lisence_info')}>
                        <p>Biển số: {detail?.license_plate?.split(": ")[1] || detail?.license_plate || ''}</p>
                        <p>Thời gian: {formatDateToTime(detail?.time) || ''}</p>
                        <p>Loại xe: {detail?.object}</p>
                    </div>
                )}
            </div>
        </Modal>
    )
}

export default ModalLicense;